import React from 'react';
import { Link, usePage } from '@inertiajs/react';
// Obrázky sú dostupné cez Laravel storage link
const home = '/storage/Home.png';
const chevron = '/storage/ChevronRight.png';

const Breadcrumb = () => {
    const { url } = usePage();

    const segments = url.split('/').filter(segment => segment);

    const formatSegment = (segment) => {
        // Odstránenie query parametrov alebo špeciálnych znakov
        const cleanedSegment = segment.split(/[?&#]/)[0];

        // Rozdelenie podľa pomlčiek a kapitalizácia
        return cleanedSegment
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const generateBreadcrumbs = () => {
        const breadcrumbs = [];
        let path = '';

        segments.forEach((segment, index) => {
            path += `/${segment}`;
            breadcrumbs.push({
                name: formatSegment(segment),
                path,
            });
        });

        return breadcrumbs;
    };

    const breadcrumbs = generateBreadcrumbs();

    return (
        <section>
            <div className="mx-auto container px-4 py-4 flex align-center my-3 flex items-center gap-8">
                <Link href="/" className='flex items-center'>
                    <img src={home} alt="home" className='h-[16px]' />
                </Link>

                {breadcrumbs.map((breadcrumb, index) => (
                    <React.Fragment key={index}>
                        <img src={chevron} alt="chevron" className='h-[10px]' />
                        <Link href={breadcrumb.path} className='font-bold text-[#1A212B]'>
                            {breadcrumb.name}
                        </Link>
                    </React.Fragment>
                ))}
            </div>
        </section>
    );
};

export default Breadcrumb;
